import { useEffect } from 'react'
import { userManager } from '@/auth/userManager'

/** Target of the hidden silent-renew iframe. Renders nothing on purpose. */
export function SilentRenewPage() {
  useEffect(() => {
    void userManager.signinSilentCallback().catch((cause) => {
      console.error('Silent renew failed', cause)
    })
  }, [])

  return null
}
